import { useState } from 'react';

const filterAmount = (v: string) => {
  const number = Number(v);
  return (!number && number !== 0) || number < 0 ? '' : v;
};

const useMainFields = (selectedCurrency: string): [string, (v: string) => void, string, (v: string) => void] => {
  const [vendorCurrency, setVendorCurrency] = useState(selectedCurrency);
  const [formAmount, setFormAmount] = useState('');

  const changeFormAmount = (v: string) => {
    setFormAmount(filterAmount(v));
  };

  return [vendorCurrency, setVendorCurrency, formAmount, changeFormAmount];
};

export default useMainFields;
